import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
	PURCHASE_ORDER_LIST,
	PURCHASE_ORDER_ROW_DATA,
	FILTERS_SHOW_RIGHT_SIDEBAR,
	FILTERS_HIDE_RIGHT_SIDEBAR,
	PDF_DOWNNLOAD,
	MR_CODE_DETAILS,
	PI_CODE_DETAILS,
	PO_ITEM_ACKNOWLEDGE,
	PURCHASE_ORDER_CLOSE,
	PURCHASE_ORDER_FOUCS_POST,
	SUBMIT_EDIT_ORDER,
	VIEW_LOG_SHOW_RIGHT_SIDEBAR_PURCHASE,
	VIEW_LOG_HIDE_RIGHT_SIDEBAR_PURCHASE,
	PO_HISTORY,
	PO_AUTHORIZATION,
} from "./actionTypes";
import {
	apiError,
	PurchaseOrderListSuccessful,
	PurchaseOrderRowDataSuccessful,
	getMRCodeDetailsSuccessful,
	getPICodeDetailsSuccessful,
	POIacknowledge_close,
	getPurchaseOrderRowData,
	getPurchaseOrderList,
	getReqestRowDetails,
	SubmitEditOrderSuccessfull,
	POCancelDescription,
	POClose_modal_close,
	ToggleEditWithValue,
	PurchaseOrderHistorySuccessful,
	getPurchaseOrderHistory,
	ToggleEdit,
	GetPoAuthorizationStatusSuccessful,
} from "./actions";
import swal from "sweetalert";
import Swal from "sweetalert2";
import {
	postAdd,
	getList,
	getParamsList,
	getDownloadFile,
	postEdit,
	// postDelete,
	// getRowData,
} from "../../helpers/Helper";
// import swal from "sweetalert";
//>>>>>>>>>>>>>>>>>>>>>>>>>

function* PurchaseOrderList({ payload: { data } }) {
	var params = {};
	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "") {
					params[k] = data[k];
				}
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/purchaseorder/list",
			params
		);

		yield put(PurchaseOrderListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* PurchaseOrderRowData({ payload: { poId } }) {
	try {
		const response = yield call(getList, "/purchaseorder/" + poId, {});
		yield put(PurchaseOrderRowDataSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* PurchaseOrderHistory({ payload: { poId, poItemId } }) {
	try {
		const response = yield call(
			getParamsList,
			`/purchaseorder/purchase-orders/history/${poId}/`,
			{ original_item_id: poItemId }
		);
		yield put(PurchaseOrderHistorySuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getMRCodeDetails({ payload: { ItemId } }) {
	try {
		const response = yield call(
			getList,
			"/purchaseorder/mrcodebypoitem/" + ItemId,
			{}
		);
		yield put(getMRCodeDetailsSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getPICodeDetails({ payload: { qitemID } }) {
	try {
		const response = yield call(
			getList,
			"/quotation/picodebyqitem/" + qitemID,
			{}
		);
		yield put(getPICodeDetailsSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* postPOiacknowledge({ payload: { data } }) {
	try {
		const response = yield call(
			postAdd,
			"/purchaseorder/poiacknowledge",
			data
		);
		if (response.status === 201) {
			yield put(POIacknowledge_close(false));
			yield put(getPurchaseOrderRowData(data.purchaseorder_id));
		}
	} catch (error) {
		yield put(apiError(error));
	}
}

function* AddPurchaseOrder({ payload: { data, purchaseId } }) {
	try {
		if (purchaseId === 0) {
			var response = {};
			response = yield call(postAdd, "/purchaseorder/", data);
			if (response.status === 201) {
				swal(" Your Quotation Added Successfully.!", {
					icon: "success",
				});
			} else {
				swal("Sorry! Unable to add quotation. Please try again!", {
					icon: "error",
				});
			}
		} else {
			const response = yield call(
				postEdit,
				"/purchaseorder/" + purchaseId,
				data
			);

			if (response.status === 200) {
				swal("Your quotation Edited Successfully.!", {
					icon: "success",
				});
				yield put(SubmitEditOrderSuccessfull());
			} else {
				swal("Sorry! Unable to edit quotation. Please try again!", {
					icon: "error",
				});
			}
		}
	} catch (error) {
		if (data.token !== "") {
			Swal.fire({
				icon: "error",
				text: "Quotation already Submited! ",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Ok",
			}).then((result) => {
				if (result.isConfirmed) {
					window.location.href = "/vendorlogin/" + data.token;
				}
			});
		} else {
			Swal.fire({
				icon: "error",
				text: "Please Try Again! ",
			});
		}

		yield put(apiError(error));
	}
}

function* UpdatePurchaseorderAuthorizationStatus({ payload }) {
	try {
		const response = yield call(
			postEdit,
			"/purchaseorder/poprint/status/" + payload.data.poId,
			payload.data
		);
		if (response.status === 200) {
			if (response.data.printapproval_status == 2) {
				swal("Approved Successfully.!", {
					icon: "success",
				});
			} else if (response.data.printapproval_status == 3) {
				swal("Rejected Successfully.!", {
					icon: "success",
				});
			}
			yield put(GetPoAuthorizationStatusSuccessful());
			yield put(
				getPurchaseOrderList({
					search: "",
					start_date: "",
					end_date: "",
					userdepartment: "",
					department: "",
				})
			);
		} else {
			swal("Sorry! Unable to Update Status. Please try again!", {
				icon: "error",
			});
		}
	} catch (error) {
		if (payload.data.token !== "") {
			Swal.fire({
				icon: "error",
				text: "Server Side Issue! ",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Ok",
			}).then((result) => {
				if (result.isConfirmed) {
					window.location.href = "/vendorlogin/" + payload.data.token;
				}
			});
		} else {
			Swal.fire({
				icon: "error",
				text: "Please Try Again! ",
			});
		}

		yield put(apiError(error));
	}
}

function* generatePDF({ payload: { POId } }) {
	try {
		yield call(getDownloadFile, "/purchaseorder/pdf/" + POId);

		// generateRFQasPDF("RFQ",response)
	} catch (error) {
		yield put(apiError(error));
	}
}
/**
 * CProduct the class on body
 * @param {*} cssClass
 */
function manageBodyClass(cssClass, action = "toggle") {
	switch (action) {
		case "add":
			if (document.body) document.body.classList.add(cssClass);
			break;
		case "remove":
			if (document.body) document.body.classList.remove(cssClass);
			break;
		default:
			if (document.body) document.body.classList.toggle(cssClass);
			break;
	}

	return true;
}

function* FilterShowRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled");
	} catch (error) {}
}
function* FilterHideRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled", "remove");
	} catch (error) {}
}
function* ViewLogShowRightSidebar({ payload: { purchaseId } }) {
	try {
		yield call(manageBodyClass, "timeLine-right-bar-enabled", "add");
		yield put(getPurchaseOrderRowData(purchaseId, true));
	} catch (error) {}
}
function* ViewLogHideRightSidebar() {
	try {
		yield call(manageBodyClass, "timeLine-right-bar-enabled", "remove");
	} catch (error) {}
}

function* ClosePurchaseOrder({ payload: { id, description } }) {
	try {
		const response = yield call(
			postAdd,
			"/purchaseorder/poclose/" + id,
			description
		);
		if (response.status === 200) {
			swal("Your Purchase Order has been closed!", {
				icon: "success",
			});
			yield put(
				POCancelDescription({
					key: "description",
					value: "",
				})
			);
			yield put(POClose_modal_close());
			yield put(
				getPurchaseOrderList({
					search: "",
					start_date: "",
					end_date: "",
					userdepartment: "",
					department: "",
				})
			);
			// yield put(SetParams({
			//   mrstatus: [0],
			//   pistatus: [0],
			//   mistatus: [0],
			//   search: "",
			//   start_date: "",
			//   end_date: "",
			//   userdepartment: "",
			//   departments: "",
			// }))
		} else {
			swal("Sorry! Your Purchase Order has been not closed!", {
				icon: "error",
			});
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}

function* FocusPostPurchaseOrder({ payload: { id } }) {
	try {
		const response = yield call(
			postAdd,
			"/thirdparty/fsyncpurchaseorder/" + id
		);
		if (response.status === 200) {
			if (response.data.result == true) {
				swal({
					title: response.data.msg,
					icon: "error",
				});
			} else {
				swal({
					title: response.data.msg,
					icon: "error",
				});
			}
			yield put(
				getPurchaseOrderList({
					search: "",
					start_date: "",
					end_date: "",
					userdepartment: "",
					department: "",
				})
			);
		} else {
			swal(
				"Sorry! selected Purchase is not posted on focus. please try again!",
				{
					icon: "error",
				}
			);
		}
	} catch (error) {
		swal("Sorry! Permission Denied!", {
			icon: "error",
		});
		yield put(apiError(error));
	}
}

export function* watchgetPurchaseOrderList() {
	yield takeEvery(PURCHASE_ORDER_LIST, PurchaseOrderList);
}

export function* watchPurchaseOrderRowData() {
	yield takeEvery(PURCHASE_ORDER_ROW_DATA, PurchaseOrderRowData);
}
export function* watchgetMRCodeDetails() {
	yield takeEvery(MR_CODE_DETAILS, getMRCodeDetails);
}
export function* watchgetPICodeDetails() {
	yield takeEvery(PI_CODE_DETAILS, getPICodeDetails);
}
export function* watchPostPOiacknowledge() {
	yield takeEvery(PO_ITEM_ACKNOWLEDGE, postPOiacknowledge);
}
export function* watchAddPurchaseOrder() {
	yield takeEvery(SUBMIT_EDIT_ORDER, AddPurchaseOrder);
}
export function* watchUpdatePurchaseorderAuthorizationStatus() {
	yield takeEvery(PO_AUTHORIZATION, UpdatePurchaseorderAuthorizationStatus);
}
export function* watchFilterShowRightSidebar() {
	yield takeEvery(FILTERS_SHOW_RIGHT_SIDEBAR, FilterShowRightSidebar);
}
export function* watchfilterHideRightSidebarr() {
	yield takeEvery(FILTERS_HIDE_RIGHT_SIDEBAR, FilterHideRightSidebar);
}
export function* watchViewLogShowRightSidebar() {
	yield takeEvery(
		VIEW_LOG_SHOW_RIGHT_SIDEBAR_PURCHASE,
		ViewLogShowRightSidebar
	);
}
export function* watchPurchaseOrderHistory() {
	yield takeEvery(PO_HISTORY, PurchaseOrderHistory);
}
export function* watchViewLogHideRightSidebar() {
	yield takeEvery(
		VIEW_LOG_HIDE_RIGHT_SIDEBAR_PURCHASE,
		ViewLogHideRightSidebar
	);
}

export function* watchgeneratePDF() {
	yield takeEvery(PDF_DOWNNLOAD, generatePDF);
}

export function* watchPurchaseOrderClose() {
	yield takeEvery(PURCHASE_ORDER_CLOSE, ClosePurchaseOrder);
}
export function* watchPoFoucsPost() {
	yield takeEvery(PURCHASE_ORDER_FOUCS_POST, FocusPostPurchaseOrder);
}
function* PurchaseOrderSaga() {
	yield all([
		fork(watchgetPurchaseOrderList),
		fork(watchPurchaseOrderRowData),
		fork(watchgetMRCodeDetails),
		fork(watchgetPICodeDetails),
		fork(watchFilterShowRightSidebar),
		fork(watchfilterHideRightSidebarr),
		fork(watchViewLogShowRightSidebar),
		fork(watchPurchaseOrderHistory),
		fork(watchViewLogHideRightSidebar),
		fork(watchgeneratePDF),
		fork(watchPostPOiacknowledge),
		fork(watchPurchaseOrderClose),
		fork(watchPoFoucsPost),
		fork(watchAddPurchaseOrder),
		fork(watchUpdatePurchaseorderAuthorizationStatus),
	]);
}

export default PurchaseOrderSaga;
